import { Menu, type MenuProps } from '@chakra-ui/react';

export type UiMenuProps = MenuProps;

export const UiMenu = Menu;
